import { IPhoneNumber } from '../../offer';

export interface IUserState {
  // TODO: При использовании постепенно заполнять тип
  agencyName?: string;
  agentAccountType: EAgentType;
  agentAvatarUrl: string;
  balance: number; // сейчас приходит string, но должен быть number
  billingInfo?: IBillingInfo;
  canPayByCard: boolean;
  canUseHiddenBase: boolean;
  cianName: string;
  cianProfileStatus: EProfileStatus;
  cianUserId: number;
  email: string;
  gaType: string;
  hasVerifiedPhoneNumber: boolean;
  homeownerInfo?: IHomeownerInfo;
  isBuilder: boolean;
  isSubAgent: boolean;
  limitedBalance: number;
  agencyBalance: number;
  moneySource?: EMoneySource;
  phoneNumbers: Array<IPhoneNumber>;
  showOffrepBanner: boolean;
  status: EAccountStatus;
  subAgentCanPublishOffers: boolean;
  termsHintAbGroup: string;
  userId: number;
  userTrustLevel: ETrustLevel;
  geo?: IUserGeo;
}

interface IBillingInfo {
  accountType: EAccountType;
  packages: Array<IPackage>;
}

interface IPackage {
  countryId: number;
  depositRequired: boolean;
  geoName: string;
  locationId: number;
  packageTypeId: EUserTariffType;
  packageTypeName: string;
}

interface IHomeownerInfo {
  userType: EHomeownerType;
  canPublishAsHomeowner: boolean;
}

/** Геопозиция пользователя */
export interface IUserGeo {
  /** квадрат координат (чего?) */
  bbox?: string;
  /** имеет ли город метро */
  hasUnderground: boolean;
  /** id локации пользователя (locationId) */
  id: number;
  /** широта локации пользователя */
  lat: number;
  /** долгота локации пользователя */
  lng: number;
  /** название города пользователя */
  name: string;
  /** название города пользователя в дательном падеже */
  name_dative: string;
}

/** Тип плательщика */
enum EAccountType {
  /** Юр. лицо */
  legal = 'legal',
  // TODO: дополнить
}

/** Тип аккаунта специалиста */
enum EAgentType {
  /** агентство */
  agency = 'agency',
  // TODO: дополнить
}

/** Тип аккаунта собственника */
export enum EHomeownerType {
  /** специалист */
  specialist = 'specialist',
  /** собственник */
  homeowner = 'homeowner',
}

/** Участие в акции "Работаю честно" */
enum ETrustLevel {
  /** Не участвует в акции */
  notInvolved = 'notInvolved',
  /** Участвует в акции */
  involved = 'involved',
  /** Новый пользователь */
  new = 'new',
  /** Исключен из программы */
  excluded = 'excluded',
  /** Очень много жалоб */
  danger = 'danger',
}

/** Статус аккаунта */
enum EAccountStatus {
  /** Активный */
  active = 'active',
  // TODO: дополнить
}

/** Статус профиля */
enum EProfileStatus {
  /** Активный */
  hide = 'hide',
  // TODO: дополнить
}

/** Тариф пользователя */
export enum EUserTariffType {
  NonCommercial = 1,
  Base = 2,
  Pro = 3,
  Builder = 5,
}

/** Источник средств субагента */
export enum EMoneySource {
  /** Со счёта агентства */
  Master = 'master',
  /** С личного счёта  */
  Self = 'self',
}
